import { useEventInfo } from "./useEventInfo.hook";

export { useEventInfo };